import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { REQUEST_STATUS } from '../constants/request-status.enum';
import { TuwaiqConfig } from '../constants/tuwaiq.config';
import { USER_ROLE } from '../constants/user-role.enum';
import { VIEW_TYPE } from '../constants/view-type.enum';
import { FilterDetails } from '../models/filter-details.model';
import { LoggedInUserService } from './logged-in-user.service';

@Injectable({
    providedIn: 'root'
})
export class ParamHandlerService {
    filteredByList: FilterDetails[] = [];

    constructor(private loggedInUserService: LoggedInUserService) {}

    setRequestListPageAndSizeParams(page: number, size: number): HttpParams {
        let parameters = new HttpParams();
        parameters = parameters.append(TuwaiqConfig.REQUEST_QUERY_PARAMS.PAGE, page);
        parameters = parameters.append(TuwaiqConfig.REQUEST_QUERY_PARAMS.SIZE, size);

        return parameters;
    }

    setTicketingSubTypeListParams(page: number, size: number, searchKeyword?: string): HttpParams {
        let parameters = new HttpParams();
        parameters = parameters.append(TuwaiqConfig.REQUEST_QUERY_PARAMS.PAGE, page);
        parameters = parameters.append(TuwaiqConfig.REQUEST_QUERY_PARAMS.SIZE, size);
        if (searchKeyword) {
            parameters = parameters.append(TuwaiqConfig.REQUEST_QUERY_PARAMS.SEARCH_QUERY, searchKeyword);
        }

        return parameters;
    }

    setIncludePendingWithParam(parameters: HttpParams): HttpParams {
        parameters = parameters.append(TuwaiqConfig.REQUEST_QUERY_PARAMS.INCLUDE, TuwaiqConfig.REQUEST_INCLUDES.PENDING_WITH);
        return parameters;
    }

    setRequestListParams(page: number, size: number, statusId: REQUEST_STATUS, viewType: VIEW_TYPE, userRole: USER_ROLE): HttpParams {
        let parameters = new HttpParams();
        parameters = this.setRequestListPageAndSizeParams(page, size);
        if (!this.isAdmissionRequestViewType(viewType)) {
            parameters = parameters.append(TuwaiqConfig.REQUEST_QUERY_PARAMS.STATUS_FILTER, statusId);
        }
        parameters = this.setSectionIdFilter(parameters);

        if (
            statusId === REQUEST_STATUS.INPROGRESS_REQUEST_STATUS ||
            statusId === REQUEST_STATUS.OPERATION_INPROGRESS_REQUEST_STATUS ||
            statusId === REQUEST_STATUS.OPERATION_COMPLETED_REQUEST_STATUS ||
            statusId === REQUEST_STATUS.OPERATION_COMPLETED_HISTORY_REQUESTS ||
            statusId === REQUEST_STATUS.CLOSED_REQUEST_STATUS
            // ||
            // ((userRole === USER_ROLE.ADMIN || userRole === USER_ROLE.SHIFT_MANAGER || userRole === USER_ROLE.SECTION_MANAGER) &&
            //     (statusId === REQUEST_STATUS.CLOSED_REQUEST_STATUS || statusId === REQUEST_STATUS.OPERATION_COMPLETED_REQUEST_STATUS))
        ) {
            // get inprogress requests
            parameters = this.setIncludePendingWithParam(parameters);

            if (viewType === VIEW_TYPE.ASSIGNED_TO_ME_REQUESTS) {
                // get assigned to me requests
                parameters = parameters.append(TuwaiqConfig.REQUEST_QUERY_PARAMS.PENDING_WITH_FILTER, this.loggedInUserService.getLoggedUserId());
            }
        }

        return parameters;
    }

    public isAdmissionRequestViewType(viewType: VIEW_TYPE): boolean {
        return [VIEW_TYPE.EMPLOYEE_MANAGEMENT_REQUESTS, VIEW_TYPE.SECURITY_COORDINATOR_REQUESTS].includes(viewType);
    }

    setSectionIdFilter(params: HttpParams): HttpParams {
        if (
            (this.loggedInUserService.getUserRole() === USER_ROLE.ADMIN ||
                this.loggedInUserService.getUserRole() === USER_ROLE.SUPER_ADMIN ||
                this.loggedInUserService.isSuperAdmin()) &&
            this.loggedInUserService.isViewAs()
        ) {
            params = params.set(TuwaiqConfig.REQUEST_QUERY_PARAMS.SECTION_FILTER, this.loggedInUserService.viewAsSection());
        }
        return params;
    }

    setParams(page: number, statusId: REQUEST_STATUS, viewType: VIEW_TYPE, userRole: USER_ROLE): HttpParams {
        let parameters = new HttpParams();
        const size = TuwaiqConfig.PAGINATION_CONFIG.DEFAULT_PAGE_SIZE;

        if (viewType === VIEW_TYPE.INPROGRESS_REQUESTS && (userRole === USER_ROLE.REQUESTER || userRole === USER_ROLE.ACCOUNT_MANAGER)) {
            //NOTE: client/requester will have both open and inprogress request returned, therefore no need to pass status id
            parameters = this.setRequestListPageAndSizeParams(page, size);
        } else {
            parameters = this.setRequestListParams(page, size, statusId, viewType, userRole);
        }

        // set filter params if any
        parameters = this.setFilterParams(parameters, viewType);

        return parameters;
    }
    setParamsTicketing(): HttpParams {
        let parameters = new HttpParams();
        const size = TuwaiqConfig.PAGINATION_CONFIG.DEFAULT_PAGE_SIZE;

        // set filter params if any

        parameters = this.setFilterParams(parameters);

        return parameters;
    }
    setParamsTicketingModule(page: number, size: number): HttpParams {
        let parameters = new HttpParams();

        // set filter params if any
        parameters = this.setRequestListPageAndSizeParams(page, size);

        parameters = this.setFilterParams(parameters);

        return parameters;
    }
    removePageAfterSelectDateFilterEService() {
        const index = this.filteredByList.findIndex(item => item.key === TuwaiqConfig.REQUEST_QUERY_PARAMS.PAGE);
        this.filteredByList.splice(index, 1);
        return this.filteredByList;
    }

    setFilterParams(parameters: HttpParams, viewType?: VIEW_TYPE): HttpParams {
        if (this.filteredByList) {
            for (let item in this.filteredByList) {
                if (this.isAdmissionRequestViewType(viewType)) {
                    if (this.filteredByList[item].key.includes('service-ids')) this.filteredByList[item].key = TuwaiqConfig.REQUEST_QUERY_PARAMS.REQUEST_TYPE;
                    if (this.filteredByList[item].key.includes('status-id')) {
                        this.filteredByList[item].removeFilter = true;
                    }
                }
                if (this.filteredByList[item].removeFilter) {
                    parameters = parameters.delete(this.filteredByList[item].key);
                } else {
                    parameters = parameters.set(this.filteredByList[item].key, this.filteredByList[item].value as string);
                }
            }
        }

        return parameters;
    }
    deleteUnnessparameterforPieChartSla(parameters: HttpParams) {
        if (this.filteredByList) {
            for (let i = 0; i < this.filteredByList.length; i++) {
                let index = this.filteredByList.findIndex(v => v.key === this.filteredByList[i].key);

                if (
                    this.filteredByList[i].key.includes('page') ||
                    this.filteredByList[i].key.includes('size') ||
                    this.filteredByList[i].key.includes('returnOnlyActiveRecords')
                    //||
                    //this.filteredByList[i].key.includes('filter[department-ids]')
                ) {
                    this.filteredByList.splice(index, 1);
                    i--;
                }
            }
        }
    }
    storeFilteredByList(filterDetails: FilterDetails[]) {
        filterDetails.forEach(element => {
            let index = this.filteredByList.findIndex(v => v.key === element.key);

            if (index === -1) {
                this.filteredByList.push(element);
            } else {
                this.filteredByList.splice(index, 1, element);
            }
        });
    }

    getFilterList() {
        return this.filteredByList;
    }

    determineIfFilterAppliedOrRemoved() {
        const filtersList = this.getFilterList();
        const activeFiltersList = filtersList.filter(i => i.removeFilter === false);
        return activeFiltersList.length > 0 ? true : false;
    }

    clearFilterParamList() {
        this.filteredByList = [];
    }

    setRequestListParamsForDashboard(page: number, id, type: string): HttpParams {
        let parameters = new HttpParams();
        parameters = this.setRequestListPageAndSizeParams(page, TuwaiqConfig.PAGINATION_CONFIG.DASHBOARD_DEFAULT_PAGE_SIZE);
        if (!this.loggedInUserService.isAccountManager()) {
            parameters = this.setIncludePendingWithParam(parameters);
        }
        if (type === 'client') {
            parameters = parameters.append(TuwaiqConfig.REQUEST_QUERY_PARAMS.CLIENTS_FILTER, id);
        }
        if (type === 'employee') {
            if (
                this.loggedInUserService.isSuperAdmin() ||
                this.loggedInUserService.isAdmin() ||
                this.loggedInUserService.isSectionManager() ||
                this.loggedInUserService.isShiftManagerIC() ||
                this.loggedInUserService.isGeneralManager()
            ) {
                parameters = parameters.append(TuwaiqConfig.REQUEST_QUERY_PARAMS.PENDING_WITH_FILTER, id);
            }
            if (this.loggedInUserService.isAccountManager()) {
                parameters = parameters.append(TuwaiqConfig.REQUEST_QUERY_PARAMS.REQUESTER_FILTER, id);
                parameters = parameters.append(TuwaiqConfig.REQUEST_QUERY_PARAMS.STATUS_FILTER, 10);
            }
        }
        if (type === 'operation') {
            parameters = parameters.append(TuwaiqConfig.REQUEST_QUERY_PARAMS.PENDING_WITH_FILTER, id);
            parameters = parameters.append(TuwaiqConfig.REQUEST_QUERY_PARAMS.STATUS_FILTER, REQUEST_STATUS.OPERATION_DASHBOARD_REQUESTS_STATUS);
        }
        // set filter params if any
        parameters = this.setFilterParams(parameters);

        parameters = this.setSectionIdFilter(parameters);

        return parameters;
    }

    setStartAndEndCreationDateParam(parameters: HttpParams, startDate, endDate): HttpParams {
        parameters = parameters.append(TuwaiqConfig.REQUEST_QUERY_PARAMS.CREATION_START_DATE_FILTER, startDate);
        parameters = parameters.append(TuwaiqConfig.REQUEST_QUERY_PARAMS.CREATION_END_DATE_FILTER, endDate);
        return parameters;
    }
}
